import React from 'react';
import { SkeletonComponent } from '@design-system';

export const FileSkeleton: React.FC = () => {
    return (
        <div>
            {[...Array(1)].map((_, index) => (
                <SkeletonComponent
                    key={index}
                    count={1}
                    style={{
                        height: '162px',
                        width: 'calc(100vw - 32px)',
                        borderRadius: '12px',
                        display: 'block'
                    }}
                />
            ))}
        </div>
    );
};
